export const appHead = {"meta":[{"charset":"utf-8"},{"name":"robots","content":""},{"name":"google-site-verification","content":"pOHWSbZdOAXJhppp2BsQn-97MSGcCGXf-NNxQRptmdg"},{"name":"_foundr","content":"cd3bebd5dcc88bb869ecc414531ee87b"},{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=1"},{"name":"fo-verify","content":"3b82d39f-6a7b-4edc-89b1-a561a3fdc8eb"},{"name":"impact-site-verification","content":"4853ce15-efdd-4788-96f6-58fb28b78c13"},{"name":"p:domain_verify","content":"4a7a7896510adbd2e8f0f9c440ccf18d"}],"link":[{"rel":"icon","href":"/favicon.ico","type":"image/png","sizes":"32x32"},{"rel":"apple-touch-icon","sizes":"180x180","href":"/apple-touch-icon.png"},{"rel":"icon","type":"image/png","sizes":"32x32","href":"/favicon-32x32.png"},{"rel":"icon","type":"image/png","sizes":"16x16","href":"/favicon-16x16.png"}],"style":[],"script":[],"noscript":[],"charset":"utf-8","viewport":"width=device-width, initial-scale=1"}

export const appPageTransition = {"name":"page","mode":"out-in"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = false

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink"}

export const asyncDataDefaults = {"deep":true}

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false